import { useEffect, useState } from "react";

const ReverseTimerClock = ({ targetTime }) => {
  const calculateTimeLeft = () => {
    const difference = new Date(targetTime) - new Date();
    return difference > 0 ? difference : 0;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
    return () => clearInterval(timer);
  }, [targetTime]);

  const formatTime = (ms) => {
    const seconds = Math.floor((ms / 1000) % 60);
    const minutes = Math.floor((ms / 1000 / 60) % 60);
    const hours = Math.floor((ms / 1000 / 60 / 60) % 24);
    const days = Math.floor(ms / 1000 / 60 / 60 / 24);
    return { days, hours, minutes, seconds };
  };

  const LABELS = {
    days: "օր",
    hours: "ժամ",
    minutes: "րոպե",
    seconds: "վրկ.",
  };

  const time = formatTime(timeLeft);

  return (
    <div className="flex flex-col gap-2 bg-white">
      <span className="text-sm text-gray-600 font-[700]">
        Քվեարկության ավարտ
      </span>
      <div className="flex gap-2">
        {Object.entries(time).map(([key, value]) => (
          <div key={key} className="flex flex-col items-center">
            <span className="bg-gray-200 rounded-[10px] w-[40px] h-[40px] flex items-center justify-center text-gray-800 border border-gray-300">
              {value}
            </span>
            <span className="text-xs text-gray-500">{LABELS[key]}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReverseTimerClock;
